/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable jsx-a11y/anchor-has-content */

// node modules
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Lightbox from 'react-images';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';
import WallpaperIcon from '@material-ui/icons/Wallpaper';

// app modules: components
import HeadContent from 'components/HeadContent';
import Icon from 'components/Icon';
import InstagramModal from 'components/InstagramModal';

// app modules: services
import { getImageSrc, getImageSize, getImageSrcSet } from 'services/image';
import { openWindow } from 'services/inAppBrowser';
import { isApp } from 'services/environment';

// app modules: props
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

// constants
import { COLOURS, BREAKPOINTS } from 'constants/index';

// assets
import CssRecipeImage from './RecipeImage.scss';
import getRecipeImageCaptionParsed from '../../api/helpers/getRecipeImageCaptionParsed';

const HEIGHT = 315;
const ADMIN_IMAGE_SIZES = [null, 1600, 1000, 500];

class RecipeImage extends PureComponent {
  static propTypes = {
    baseUrl: PropTypes.string.isRequired,
    enableLightbox: PropTypes.bool,
    instagramThumbnailUrl: PropTypes.string,
    contentRaw: PropTypes.arrayOf(PropTypes.string),
    instagramPostUrl: PropTypes.string,
    instagramAuthor: PropTypes.string,
    instagramThumbnailWidth: PropTypes.number,
    instagramThumbnailHeight: PropTypes.number,
    instagramHtml: PropTypes.string,
    instagramWidth: PropTypes.number,
    bodyWidth: PropTypes.number.isRequired,
    isCkbkEditor: PropTypes.bool,
    imageHintFromReferer: RecipeImageProps.graphics,
    isInitialPage: PropTypes.bool,
    displayType: PropTypes.string,
    image: RecipeImageProps.graphic,
    graphics: RecipeImageProps.graphics,
  };

  static defaultProps = {
    enableLightbox: true,
    instagramThumbnailUrl: null,
    instagramPostUrl: null,
    instagramAuthor: null,
    instagramThumbnailWidth: HEIGHT,
    instagramThumbnailHeight: HEIGHT,
    instagramHtml: null,
    instagramWidth: 640,
    isCkbkEditor: false,
    image: null,
    imageHintFromReferer: null,
    isInitialPage: false,
    displayType: null,
    graphics: [],
    contentRaw: null,
  };

  constructor(props) {
    super(props);

    this.bound = {
      openLightbox: this.openLightbox.bind(this),
      closeLightbox: this.closeLightbox.bind(this),
    };

    this.state = {
      isOpenLightbox: false,
      rootWidth: props.bodyWidth,
    };

    this.containerRef = React.createRef();
    this.resizeObserver = null;
  }

  componentDidMount() {
    if (this.containerRef.current) {
      this.resizeObserver = new ResizeObserver(entries => {
        if (entries.length) {
          const rootWidth = entries[0].contentRect.width;
          if (rootWidth) {
            this.setState({
              rootWidth,
            });
          }
        }
      });
      this.resizeObserver.observe(this.containerRef.current);
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  openLightbox() {
    const { instagramPostUrl, displayType } = this.props;
    if (instagramPostUrl && displayType === 'mobile') {
      openWindow(instagramPostUrl, '_blank');
    } else {
      this.setState({
        isOpenLightbox: true,
      });
    }
  }

  closeLightbox() {
    this.setState({
      isOpenLightbox: false,
    });
  }

  closeLightboxAndNavigate(event, selector) {
    event.preventDefault();
    this.setState({ isOpenLightbox: false }, () => {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  renderBannerInstagramCaption(primaryImage, snapToEdges) {
    const {
      instagramThumbnailHeight,
      instagramThumbnailWidth,
      instagramPostUrl,
      instagramAuthor,
    } = this.props;
    const { rootWidth } = this.state;

    const aspectRatio = instagramThumbnailWidth / instagramThumbnailHeight;
    const imageWidth = HEIGHT * aspectRatio;
    const gutter = rootWidth <= BREAKPOINTS.PHONE_HORIZONTAL ? 30 : 0;
    const right = (snapToEdges ? gutter : Math.min(1024, rootWidth + gutter) - imageWidth) / 2;
    return (
      <figcaption style={{ right }} className="recipe-image__caption">
        <span className="recipe-image__caption__text">
          <a href={instagramPostUrl} className="link link--light" target="_blank">
            @{instagramAuthor}
          </a>
        </span>
        {primaryImage.type === 'instagram' ? (
          <Icon fill={COLOURS.WHITE} name="instagram" height="30" width="30" ml="5" />
        ) : null}
      </figcaption>
    );
  }

  renderBlessedImageCaption(primaryImage, snapToEdges) {
    const { rootWidth } = this.state;

    const aspectRatio = primaryImage.width / primaryImage.height;
    const imageWidth = HEIGHT * aspectRatio;
    const gutter = rootWidth <= BREAKPOINTS.PHONE_HORIZONTAL ? 0 : 60;
    const right = (snapToEdges ? gutter : Math.min(1024, rootWidth + gutter) - imageWidth) / 2;

    return (
      <figcaption
        style={{ right: right < 0 ? 0 : right }}
        className="recipe-image__caption recipe-image__caption-blessed"
      >
        <span className="recipe-image__caption__text">
          <img src="images/logo-white.png" alt="recipe review blessed" height="22" />
        </span>

        <WallpaperIcon />
      </figcaption>
    );
  }

  renderFigureCaption(existingCaption) {
    const { image, contentRaw } = this.props;

    if (image && image.userCredits) {
      const reviewUrl = `#review${image.userCredits.comment_id}`;

      return (
        <p>
          Photo: Recipe review by{' '}
          <a
            className="link link--energized"
            onClick={e => this.closeLightboxAndNavigate(e, reviewUrl)}
            href={reviewUrl}
          >
            {image.userCredits.username}
          </a>
        </p>
      );
    }

    const imgFigCaptionContent = getRecipeImageCaptionParsed(contentRaw);

    return imgFigCaptionContent ? (
      <div
        dangerouslySetInnerHTML={{
          __html: imgFigCaptionContent,
        }}
      />
    ) : (
      existingCaption
    );
  }

  renderLightboxCaption(image) {
    const { isCkbkEditor, graphics, baseUrl } = this.props;

    const caption = Array.isArray(image.credit)
      ? image.credit.map(line => <p key={line}>{line}</p>)
      : image.credit;

    const bestImage =
      graphics.find(g => g.graphictype === 'photo_large' && g.type === 'recipegraphic-primary') ||
      image;
    const handleAdminLinkClick = isApp()
      ? e => {
          e.preventDefault();
          openWindow(e.target.href, '_system');
          return false;
        }
      : null;

    return isCkbkEditor ? (
      <div>
        Download image:{' '}
        {ADMIN_IMAGE_SIZES.map((size, index) => {
          const itemKey = `${bestImage.src}-${size}-${index}w`;
          if (!size) {
            return (
              <a
                key={itemKey}
                onClick={handleAdminLinkClick}
                target="_blank"
                href={`${baseUrl}/admin/images/${bestImage.src}`}
                className="link link--energized"
                download={bestImage.src}
              >
                Full size
              </a>
            );
          }

          return (
            <Fragment key={itemKey}>
              ,{' '}
              <a
                onClick={handleAdminLinkClick}
                target="_blank"
                href={`${baseUrl}/admin/images/${bestImage.src}?width=${size}`}
                className="link link--energized"
                download={`${bestImage.src.replace('.jpg', '')}-${size}w.jpg`}
              >
                {`${size}px`}
              </a>
            </Fragment>
          );
        })}
        <br />
        {this.renderFigureCaption(caption)}
      </div>
    ) : (
      this.renderFigureCaption(caption)
    );
  }

  render() {
    const { isOpenLightbox, rootWidth } = this.state;
    const {
      displayType,
      enableLightbox,
      imageHintFromReferer,
      instagramHtml,
      instagramWidth,
      isInitialPage,
      image,
    } = this.props;

    const primaryImage = image || imageHintFromReferer;
    const originalCrop = primaryImage?.crops?.find(crop => crop.type === 'original');

    const containerAspectRatio = rootWidth / HEIGHT;

    const snapToEdges =
      Math.abs(containerAspectRatio - originalCrop?.aspect_ratio) < 0.33 &&
      originalCrop?.aspect_ratio >= 0.8;

    const shareImage =
      getImageSize(primaryImage, 'share', size => size.w <= 2000 && size.h <= 2000, {
        searchHighToLow: true,
      }) ||
      getImageSize(primaryImage, 'original', size => size.w <= 2000 && size.h <= 2000, {
        searchHighToLow: true,
      });

    const bannerImage =
      getImageSize(primaryImage, 'original', size => size.h <= 315, {
        searchHighToLow: true,
      }) || getImageSize(primaryImage, 'original', size => size.h >= 300);

    // On the initial page load force the 1x image for mobile to help LCP
    const reduceQuality = displayType === 'mobile' && isInitialPage;

    if (
      (image?.type === 'primary' ||
        image?.type === 'instagram' ||
        image?.type === 'blessedimage') &&
      bannerImage?.src
    ) {
      const imageTooSmallForContainer = bannerImage?.h < HEIGHT;
      const imageIsClickable = (!image.lowres && enableLightbox) || image.type === 'instagram';

      const recipeImageClassName = classNames('recipe-image', {
        'recipe-image--portrait': true,
        'recipe-image--landscape': snapToEdges,
        'recipe-image--tiny-res': imageTooSmallForContainer,
        'recipe-image--clickable': imageIsClickable,
      });
      const lightboxImage = {
        src:
          getImageSrc(primaryImage, 'original', size => size.w >= 500) ||
          getImageSrc(primaryImage, 'original', () => true, { searchHighToLow: true }),
        srcSet:
          getImageSrcSet(primaryImage, 'original', size => size.w >= 500) ||
          getImageSrcSet(primaryImage, 'original', () => true, { searchHighToLow: true }),
        caption: this.renderLightboxCaption(primaryImage),
      };
      const lightbox =
        isOpenLightbox && lightboxImage?.src ? (
          <div className="recipe-image__lightbox">
            <Lightbox
              backdropClosesModal
              images={[lightboxImage]}
              isOpen={isOpenLightbox}
              onClose={this.bound.closeLightbox}
              showImageCount={false}
              theme={{ image: { userSelect: 'none', pointerEvents: 'none' } }}
            />
          </div>
        ) : null;
      return (
        <div ref={this.containerRef} className="margin-bottom-20">
          <HeadContent
            contents={{
              content: shareImage?.src,
              width: shareImage?.w,
              height: shareImage?.h,
              largeImage: shareImage?.src,
            }}
          />
          {image?.type === 'instagram' && instagramHtml ? (
            <InstagramModal
              html={instagramHtml}
              maxWidth={instagramWidth}
              onClose={this.bound.closeLightbox}
              open={isOpenLightbox}
            />
          ) : (
            lightbox
          )}
          <figure
            className={recipeImageClassName}
            onClick={imageIsClickable ? this.bound.openLightbox : null}
          >
            <img
              className="recipe-image__image"
              src={bannerImage?.src}
              srcSet={
                reduceQuality
                  ? null
                  : getImageSrcSet(primaryImage, 'original', [
                      { x: 1, h: bannerImage?.h },
                      // For low res images we will shrink dimensions to preserve quality
                      {
                        x: 2,
                        h: imageTooSmallForContainer ? bannerImage?.h : bannerImage?.h * 1.75,
                      },
                    ])
              }
              alt="banner"
              key={bannerImage?.src}
              height={imageTooSmallForContainer ? bannerImage?.h : HEIGHT}
            />
            {image?.type === 'instagram'
              ? this.renderBannerInstagramCaption(primaryImage, snapToEdges)
              : null}
            {image?.type === 'blessedimage'
              ? this.renderBlessedImageCaption(primaryImage, snapToEdges)
              : null}
          </figure>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => ({
  bodyWidth: state.dimensions?.layout?.panel,
  isCkbkEditor: state.user.permissions && state.user.permissions.includes('collections:edit'),
  imageHintFromReferer: state.router.locationState?.imageHint,
  displayType: state.dimensions.displayType,
  baseUrl: state.config.baseUrl,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(CssRecipeImage)(RecipeImage));
